import React, { useEffect, useState } from "react";
import { Container, Grid} from "@mui/material";
import { motion } from "framer-motion";

import CampaignDetail from "./component/CampaignDetail";
import CreateModel from "./component/CreateModel";
import { useDispatch, useSelector } from "react-redux";
import { showLoading } from "../../redux/actions/campaign.actions";
import axiosInstance from "../../utils/axiosInterceptor";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg";
import { toast } from "react-hot-toast";
import { fetchCampaigns } from "../../redux/actions/campaignsFilter.actions";
import useDebounce from "../../hooks/useDebounce";
import CommonCardList from "../../components/comman/new-cards/CommanCards";
import CreateCampaignCard from "./component/CardComponent";
import { fetchCollectionsv3 } from "../../redux/actions/collections.actions";
import { fetchCampaignById } from "../../redux/actions/campaignByID.action";
import NoDataFound from "../../components/comman/nodDataFound/NoDataFound";
import "./campaign.scss";

const Campaign = () => {
	const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
	const { user } = useSelector((state) => state.authReducer);
	const { loading } = useSelector((state) => state.campaignReducer);
	const dispatch = useDispatch();
	const { user_roleid } = user;
	const [openDetails, setOpenDetails] = useState(false);
	const [campaignId, setCampaignId] = useState(null);
	const [openCreateModel, setOpenCreateModel] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [alertMessage, setAlertMessage] = useState({
		alertType: "success",
		alertMsg: "Successfull",
		showAlert: false,
	});
	const [compaignSearch, setCompaignForSearch] = useState([]);
	const [modal, setModal] = useState(false);
	const [campaignDelete, setCampaignDelete] = useState(null);
	const [campName, setCampName] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const { data: campaignData, page, totalPages, loading: loadingFilter, error } = useSelector((state) => state?.campaignFilterReducer)
	const collectionData = useSelector((state) => state?.collectionNewReducer?.collections)
	const campaignIdData = useSelector((state) => state?.campaignNewReducer?.campaign?.data?.data?.[0])
	const updateCampaignData = useSelector((state) => state?.campaignNewReducer?.campaign?.data?.data?.[0])

	const [campaignDatas, setCampaignDatas] = useState(updateCampaignData || {});

	const handleAlert = (msg, type) => {
		setAlertMessage({
			alertType: type ? type : "success",
			alertMsg: msg ? msg : "Operation successfull",
			showAlert: !alertMessage.showAlert,
		});
	};
	const onHandleDetails = async ({ id: campaign_id }) => {
		dispatch(fetchCampaignById(campaign_id));
		setCampaignId(campaign_id);
		setOpenDetails(!openDetails);
	};
	const [types, setTypes] = useState({
		pay_type: "",
		pay_method: "",
		bankcode: ""
	});

	const onHandleEdit = async ({ id: campaign_id }) => {
		setCampaignId(campaign_id);
		setIsEdit(true);
		setOpenCreateModel(true);
		dispatch(fetchCampaignById(campaign_id));
		dispatch(fetchCollectionsv3())
		setTypes({
			pay_type: "",
			pay_method: "",
			bankcode: ""
		});
		setCampaignDatas({})
		dispatch({ type: "RESET_CAMPAIGN" }); // Reset campaign data
	};

	const handleOpen = (campaigns) => {
		setCampName(campaigns?.title);
		setCampaignDelete(campaigns?.id);
		setModal(true);
		setTypes({
			pay_type: "",
			pay_method: "",
			bankcode: ""
		});
		setCampaignDatas({});
	}


	const onHandleDelete = async () => {
		dispatch(showLoading(true));
		try {
			const res = await axiosInstance.delete(`${host}/api/v1/campaigns/${campaignDelete}`);
			dispatch(showLoading(false));
			handleAlert("Deleted Successfully ", "success");
			dispatch(fetchCampaigns(currentPage, 10))
			toast.success("Campaign deleted successfully")
			setModal(false);
		} catch (err) {
			dispatch(showLoading(false));
			handleAlert(err, "error");
			console.log(`Error : ${err}`);
			toast.error("Something went wrong while deleting campaign")
		}
	};

	const onHandleCreateModel = () => {
		setIsEdit(false);
		setOpenCreateModel(true);
		dispatch(fetchCollectionsv3())
		dispatch({ type: "RESET_CAMPAIGN" }); // Reset campaign data
		setTypes({
			pay_type: "",
			pay_method: "",
			bankcode: ""
		})
		setCampaignDatas({});
	};


	const onPageChange = (newPage) => {
		if (newPage !== currentPage) {
			setCurrentPage(newPage); // ✅ Update page
		}
	};

	const debouncedCamName = useDebounce(compaignSearch, 600);
	const Pagination = useDebounce(currentPage, 600);

	useEffect(() => {
		dispatch(fetchCampaigns(currentPage, 10, debouncedCamName));
	}, [debouncedCamName, dispatch, Pagination]);


	return (
		<Container className="campaign-management">
			<Grid
				className='main-grid'
				container
				direction='row'
				justifyContent='center'
				alignItems='top'
				columns={{ xs: 6, md: 12 }}
				rowSpacing={1}
				columnSpacing={{ xs: 1, sm: 1, md: 2 }}>
				<Grid item xs={11.5}>
					<motion.div
						className="campaign-management-intro"
						initial={{ opacity: 0, y: -16 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45, ease: "easeOut" }}
					>
						<h2>Campaign Management Overview</h2>
						<p>
							Create, review, and manage campaign performance with quick actions from one dashboard.
						</p>
					</motion.div>
				</Grid>
				<Grid item xs={11.5} justifySelf='center'>
					{(user_roleid === 1 || user_roleid === 2 || user_roleid === 4) &&
						<CreateCampaignCard onClick={onHandleCreateModel} btnText={"Create Campaign"} heading={"Campaigns"} />
					}
				</Grid>
				<div className="flex justify-end items-end mb-2 mt-4 w-full">
					<input
						type="text"
						placeholder="Search by Campaign Name & Campaign ID & Campaign URL..."
						value={compaignSearch}
						onChange={(e) => setCompaignForSearch(e.target.value)}
						className="shadow-sm border rounded-md px-4 py-2 w-1/2"
					/>
				</div>
				{campaignData?.length > 0 ?
					<CommonCardList
						data={campaignData}
						currentPage={currentPage}
						totalPages={totalPages}
						onPageChange={(data) => onPageChange(data)}
						onView={onHandleDetails}
						onEdit={(id) => onHandleEdit(id)}
						onDelete={(id) => handleOpen(id)}
						showSearch={true}
						setCompaignForSearch={setCompaignForSearch}
						compaignSearch={compaignSearch}
						loadingFilter={loadingFilter}
					/>
					:
					<>
						<NoDataFound/>
					</>
				}
			</Grid>

			<CampaignDetail
				open={openDetails}
				setOpenDetails={setOpenDetails}
				campaignId={campaignId}
				campaignIdData={campaignIdData}
				collectionData={collectionData}
			/>
			<CreateModel
				isEdit={isEdit}
				campaignId={campaignId}
				open={openCreateModel}
				openCreateModel={openCreateModel}
				setOpenCreateModel={setOpenCreateModel}
				collectionData={collectionData}
				campaignList={campaignData}
				handleAlert={handleAlert}
				refreshDetails={() => dispatch(fetchCampaigns(currentPage, 10))}
				campaignIdData={campaignIdData}
				updateCampaignData={updateCampaignData}
				setIsEdit={setIsEdit}
				types={types}
				setTypes={setTypes}
				setCampaignData={setCampaignDatas}
				campaignData={campaignDatas}
			/>

			<MessageDialog
				open={modal}
				onClose={() => setModal(false)}
				title=" Camapigns Delete"
				message={`Are you sure you want to delete this Campaigns ${campName} ?`}
				okText={`Delete`}
				variant={"error"}
				img={`https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1748122267846-assets_task_01jw2360pqec98vpmf1vxzjzrm_1748122215_img_2.webp`}
				onConfirm={onHandleDelete}
			/>
		</Container>
	);
};

export default Campaign;
